import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { PageHeader, PlanUsagePanel, ServicePlanBillingCard } from 'components'
import { useSubscriptionUsage } from 'context/subscription-usage'
import {
    ACCOUNT_CHECKOUT_PATH,
    ENABLE_LICENSE_SHOPPING_CART,
    ENABLE_SERVICE_PLAN_STRIPE_FLOW,
} from 'utility/subscription-usage'

const Page = styled.div`
    padding: 8px 4px 24px;
    @media (max-width: 930px) {
        padding: 4px 0 20px;
    }
`

const Breadcrumb = styled.p`
    font-size: 13px;
    color: #6b7280;
    margin: 4px 0 16px;
    strong {
        color: #111827;
        font-weight: 600;
    }
`

const ApiNote = styled.div`
    margin-bottom: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 1.5;
    background: #fffbeb;
    border: 1px solid #fde68a;
    color: #92400e;
`

/**
 * Account & Plan — Settings tab.
 * Free-plan usage UI + Stripe billing gated by flags in subscription-usage.js.
 */
export const AccountPlanScreen = () => {
    const { refetchUsage, usage } = useSubscriptionUsage()
    const [paidConfirmed, setPaidConfirmed] = useState(null)
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        refetchUsage()
    }, [refetchUsage])

    useEffect(() => {
        if (!ENABLE_LICENSE_SHOPPING_CART) return
        if (searchParams.get('upgrade') !== '1') return
        navigate(ACCOUNT_CHECKOUT_PATH, { replace: true })
    }, [searchParams, navigate])

    return (
        <Page>
            <PageHeader header="Account & Plan" />
            <Breadcrumb>
                Settings › <strong>Account & Plan</strong>
            </Breadcrumb>
            {usage?._usageApiUnavailable && (
                <ApiNote>
                    Subscription usage API is not available yet (
                    <code>GET /Subscription/Usage</code>). Showing Free-plan UI
                    from login ServicePlan so widgets can be reviewed. Counts
                    may be provisional until the backend endpoint is live.
                </ApiNote>
            )}
            {ENABLE_SERVICE_PLAN_STRIPE_FLOW && (
                <ServicePlanBillingCard
                    onBillingChanged={refetchUsage}
                    onPaidStatusChange={setPaidConfirmed}
                />
            )}
            <PlanUsagePanel
                forceFree={paidConfirmed === false}
                showBanner
                showBannerUpgrade={false}
                showUpgradeActions={false}
                onUpgrade={() => navigate(ACCOUNT_CHECKOUT_PATH)}
            />
        </Page>
    )
}
